import React, { FC, useState } from "react";
import { Heading } from "@digipost/dds-heading-react";
import Translated from "../infrastructure/translation/Translated";
import illustration from "../../assets/illustrations/store_bedrifter.svg";
import styles from "./KontaktinfoWrapper.module.less";

import {
  ButtonGroup,
  PrimaryButton,
  SecondaryButton,
} from "@digipost/dds-buttons-react";
import { Input } from "@digipost/dds-input-react";
import { useTranslate } from "../infrastructure/translation/useTranslate";
import { emailValidator } from "../infrastructure/validation/validation";
import { usePreselectedOrgnr } from "../PartnerOnboarding/usePreselectedOrgnr";
import { OppsummeringBody } from "../Oppsummering/OppsummeringBody";
import { Organisasjonsnummer } from "../Organisasjonsnummer/Organisasjonsnummer";
import { useRegistreringContext } from "../Registreringsflyt/useRegistreringContext";

const KontaktinfoWrapper: FC = (): React.ReactElement => {
  const {
    valgtForetak,
    kontaktInfo,
    setKontaktInfo,
    previousStep,
    nextStep,
    reset,
  } = useRegistreringContext();

  const preselectedOrgnr = usePreselectedOrgnr();
  const translate = useTranslate();

  const [companyEmail, setCompanyEmail] = useState<string>(
    kontaktInfo?.companyEmail || "",
  );
  const [personalEmail, setPersonalEmail] = useState<string>(
    kontaktInfo?.personalEmail || "",
  );

  const [companyEmailValid, setCompanyEmailValid] = useState<boolean>(true);
  const [personalEmailValid, setPersonalEmailValid] = useState<boolean>(true);

  const foretak = valgtForetak?.foretak;
  if (!foretak) {
    return reset();
  }

  const submitForm = (e: React.FormEvent) => {
    e.preventDefault();
    const validCompanyEmail = emailValidator(companyEmail);
    setCompanyEmailValid(validCompanyEmail);

    const validPersonalEmail = emailValidator(personalEmail);
    setPersonalEmailValid(validPersonalEmail);

    if (validCompanyEmail && validPersonalEmail) {
      setKontaktInfo({
        companyEmail,
        personalEmail,
        orgNr: foretak.orgnummer,
        virksomhetsNavn: foretak.navn,
      });
      nextStep();
    }
  };

  const resetAndGoBack = () => {
    setKontaktInfo(undefined);
    previousStep();
  };

  return (
    <section className={styles.wrapper}>
      <img src={illustration} alt="" />
      <Heading level={1} size={"large"} className={styles.heading}>
        <Translated textKey={"contact.header"} />
      </Heading>
      <Translated textKey={"contact.body"} />

      <OppsummeringBody
        extraClassName={styles.virksomhetOppsummering}
        summaryPoints={[
          {
            headerKey: "generic.business",
            values: [
              foretak.navn,
              <Organisasjonsnummer orgNr={foretak.orgnummer} />,
            ],
          },
        ]}
      />

      <form onSubmit={submitForm}>
        <fieldset className={styles.wrapper}>
          <Input
            name={"companyEmail"}
            inputType={"email"}
            labelText={translate("contact.email_company")}
            autoComplete={"email"}
            value={companyEmail}
            valid={companyEmailValid}
            errorText={companyEmailValid ? "" : translate("validation.email")}
            onChange={(e) => setCompanyEmail(e.target.value)}
          />
          <Input
            name={"personalEmail"}
            inputType={"email"}
            labelText={translate("contact.email_personal")}
            autoComplete={"email"}
            value={personalEmail}
            valid={personalEmailValid}
            errorText={personalEmailValid ? "" : translate("validation.email")}
            onChange={(e) => setPersonalEmail(e.target.value)}
          />
        </fieldset>
        <ButtonGroup>
          {!preselectedOrgnr && (
            <SecondaryButton type="button" onClick={resetAndGoBack}>
              <Translated textKey={"generic.back"} />
            </SecondaryButton>
          )}
          <PrimaryButton type="submit">
            <Translated textKey={"generic.next"} />
          </PrimaryButton>
        </ButtonGroup>
      </form>
    </section>
  );
};

export default KontaktinfoWrapper;
